(function () {
  'use strict';

  /* @ngdoc object
   * @name main.formulari
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.formulari', [
      'ui.router'
    ]);
}());
